import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
// import { createStore, combineReducers } from 'redux'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import userRoleSlice from './roles/userRoleSlice'
import userApiSlice from './roles/userApiSlice'
import navigateSlice from './NavigateData/navigateSlice'
import  treeDataSlice  from './TreeData/TreeDataSlice'
import {configureStore, combineReducers} from "@reduxjs/toolkit"
import {thunk} from 'redux-thunk';

const persistConfig = {
    key: '-root',
    storage,
    stateReconciler: autoMergeLevel2,
}

const rootReducer = combineReducers({
    userRoleRed:userRoleSlice,
    userKeyRed:userApiSlice,
    navigateRed:navigateSlice,
    treeDataRed:treeDataSlice
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const reduxStore = configureStore({reducer:persistedReducer,devTools: process.env.NODE_ENV !== 'production',middleware: [thunk]})

export const persistor = persistStore(reduxStore, {}, () => {
     
})

